
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 10a5 5 0 10-4.64-3.17l-7.07 3.65a4 4 0 10-.07 4.61l8.96 4.93c-.11.3-.18.63-.18.98a3 3 0 103-3c-.95 0-1.79.45-2.34 1.14l-8.95-4.92a3.97 3.97 0 00.03-2.84l7.08-3.66A5 5 0 0019 10zm0 9a2 2 0 110 4 2 2 0 010-4zM4 15.75a3 3 0 11.01-6 3 3 0 01-.01 6zM19 1a4 4 0 11-.01 8 4 4 0 010-8.01z"}})])
          )
        }
      }
    